import React from "react";
import {Box, Button, Container, Stack, Typography} from "@mui/joy";
import {CheckCircleOutlined} from "@mui/icons-material";
import {Link} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {GlassCard} from "../components/GlassCard";
import {Layout} from "../components/Layout";


export function Confirmation() {
    const { t } = useTranslation();

    return (
        <Layout>
            <Container maxWidth="xs" sx={{flex: 1, display: "flex", alignItems: "center", py: {xs: 4, sm: 6}, px: {xs: 2, sm: 3}}}>
                <GlassCard sx={{width: "100%", p: {xs: 3, sm: 4}, borderColor: "rgba(60,200,110,0.35)"}}>
                    <Stack spacing={1} justifyContent="center" alignItems="center" textAlign="center">
                        <Box sx={{
                            width: 56, height: 56, borderRadius: "50%",
                            display: "flex", alignItems: "center", justifyContent: "center",
                            backgroundColor: "rgba(60,200,110,0.15)", color: "#3ec86e", mb: 1,
                        }}>
                            <CheckCircleOutlined sx={{fontSize: 32}} />
                        </Box>
                        <Typography level="h3">{t("paymentcompleted")}</Typography>
                        <Typography level="body-md" sx={{color: "neutral.400", pb: 3}}>{t("paymentcompletedlabel")}</Typography>
                        <Stack spacing={1} sx={{width: "100%"}}>
                            {/* Deep link cinefx:// — vedi
                                cinefx_flutter/lib/core/deep_link/
                                deep_link_provider.dart. Su
                                desktop/senza app installata non fa
                                nulla di dannoso: resta comunque il
                                link "Torna al tuo account" sotto. */}
                            <Button
                                color="success"
                                onClick={() => {
                                    window.location.href = "cinefx://subscription-updated";
                                }}
                            >
                                {t("backtoapp")}
                            </Button>
                            <Link to="/" style={{width: "100%"}}>
                                <Button color="neutral" variant="plain" sx={{width: "100%"}}>
                                    {t("backtoaccount")}
                                </Button>
                            </Link>
                        </Stack>
                    </Stack>
                </GlassCard>
            </Container>
        </Layout>
    )
}
